let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("40KVc")).then(() => parcelRequire('a4fxs'));